import React from 'react';
import { ILandingPageDesignResponse } from '../../../types';
import { LandingPageDesignPreviewContainer } from './styles';
import { Header } from './Header';
import { Footer } from './Footer';
import { Body } from './Body';
import { DesignThumbnail } from '../../../styles';
import fallbackImage from '../../../assets/fallbackImage.png';
import { FlexProps } from 'lib/components/styles/layout';

interface ILandingPageDesignThumbnailPreview {
  landingPageDesign: ILandingPageDesignResponse;
  extendStyles?: {
    container?: FlexProps;
  };
}

export const LandingPageDesignThumbnailPreview = ({
  landingPageDesign,
  extendStyles,
}: ILandingPageDesignThumbnailPreview) => {
  if (!landingPageDesign) {
    return <DesignThumbnail src={fallbackImage} />;
  }
  const { fontFamily } = landingPageDesign;
  return (
    <LandingPageDesignPreviewContainer
      fontFamily={fontFamily}
      style={extendStyles?.container}
    >
      <Header landingPageDesign={landingPageDesign} />
      <Body landingPageDesign={landingPageDesign} />
      <Footer landingPageDesign={landingPageDesign} />
    </LandingPageDesignPreviewContainer>
  );
};
